// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".course-favorite[data-v-1e454a75]{align-items:center;background-color:#fff;border-radius:50px;display:flex;gap:8px;opacity:.7;padding:6px 12px;position:absolute;right:8px;top:8px}.icon[data-v-1e454a75]{height:16px;width:16px}.icon.fill[data-v-1e454a75]{color:#ff5855}.icon.empty[data-v-1e454a75]{color:#495057}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
